import React, { FC, useRef, useEffect } from 'react'
import { Box, Image, Heading, Text, Link } from '@gassan-ui'
import * as S from './elements'
import { getKontentImage } from '@lib/kontent'
import { SlideContainer } from './elements'
import { ContentSlide } from '@lib/kontent/models/ContentSlide'
import { strippedHtmlLength } from '@components/_content-page/stripped-html-length'
import RichContentField from '@components/_content-page/RichContentField'

type Props = ContentSlide & {
  isActive: boolean
}

const Slide: FC<Props> = ({
  title,
  text,
  rich_content,
  link_text,
  link_url,
  image,
  mobile_image,
  image_is_logo,
  isActive
}) => {
  const hasBeenActive = useRef(false)
  const hasRichContent = rich_content.value ? strippedHtmlLength(rich_content.value) > 0 : false

  useEffect(() => {
    if (isActive && !hasBeenActive.current) {
      hasBeenActive.current = true
    }
  }, [isActive])

  const imageLoading = isActive || hasBeenActive.current ? 'lazy' : 'none'

  return (
    <>
      <SlideContainer>
        <S.ImageBox isLogo={!!image_is_logo.value[0]}>
          {image && (
            <Image
              placeholderSrc={getKontentImage(mobile_image.value[0]?.url, { width: 50 })}
              sources={[
                getKontentImage(mobile_image.value[0]?.url, { width: 700 }),
                getKontentImage(mobile_image.value[0]?.url, { width: 700 }),
                getKontentImage(image.value[0]?.url, { width: 700 })
              ]}
              ratio={[0.55, 0.55, 0.8]}
              alt={image.value[0]?.description}
              loading={imageLoading}
            />
          )}
        </S.ImageBox>
        <Box
          pt={{ _: '2rem', small: '3rem', large: '0' }}
          pb={{ _: '2rem', small: '4rem', large: '0' }}
          px={{ _: '0.75rem', small: '0', large: '0' }}
        >
          <Heading variant="h2" as="h2" mb={['1rem', '1.5rem']}>
            {title.value}
          </Heading>
          {hasRichContent ? (
            <S.ContentBox columns={rich_content.value.length > 400 ? 2 : 1}>
              <RichContentField {...rich_content} />
            </S.ContentBox>
          ) : (
            <S.ContentBox columns={text.value.length > 400 ? 2 : 1}>
              <Text style={{ whiteSpace: 'pre-line' }}>{text.value}</Text>
            </S.ContentBox>
          )}
          {link_text && link_url && (
            <Box mt="1rem" display="inline-block">
              <Link variant="brown" href={link_url.value}>
                {link_text.value}
              </Link>
            </Box>
          )}
        </Box>
      </SlideContainer>
    </>
  )
}

export default Slide
